import { render, staticRenderFns } from "./PhoneField.vue?vue&type=template&id=15484c8c&scoped=true&"
import script from "./PhoneField.vue?vue&type=script&lang=js&"
export * from "./PhoneField.vue?vue&type=script&lang=js&"
import style0 from "./PhoneField.vue?vue&type=style&index=0&id=15484c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15484c8c",
  null
  
)

export default component.exports